var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConcentric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11771_94919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.35 2.65039H7.34998V3.40039H16.35V2.65039Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43686 2.65031L1.34998 9.7959L2.00101 10.1683L6.0879 3.02267L5.43686 2.65031Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.958455 12.304L5.36182 20.2734L6.01828 19.9107L1.61491 11.9413L0.958455 12.304Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1652 10.1509L17.85 18.6406L18.5186 18.9805L22.8338 10.4907L22.1652 10.1509Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5714 3.36134L20.3043 10.5225L20.9694 10.1758L17.2365 3.01466L16.5714 3.36134Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.85 10.9004H13.35V11.6504H20.85V10.9004Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.35 10.9004H2.84998V11.6504H13.35V10.9004Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0118 11.4388L7.69641 3.57324L7.075 3.99318L12.3904 11.8587L13.0118 11.4388Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3326 10.2942L6.1499 19.5576L6.80443 19.9238L11.9871 10.6604L11.3326 10.2942Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2344 10.8916L16.65 20.4326L17.3023 20.0624L11.8867 10.5214L11.2344 10.8916Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0664 10.9575L18.4268 3.52734L17.8185 3.08854L12.4582 10.5187L13.0664 10.9575Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.35 19.1504H7.34998V19.9004H16.35V19.1504Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59995 5.8C7.92543 5.8 8.99995 4.72548 8.99995 3.4C8.99995 2.07452 7.92543 1 6.59995 1C5.27447 1 4.19995 2.07452 4.19995 3.4C4.19995 4.72548 5.27447 5.8 6.59995 5.8Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 22.0008C7.7598 22.0008 8.7 21.0606 8.7 19.9008C8.7 18.741 7.7598 17.8008 6.6 17.8008C5.4402 17.8008 4.5 18.741 4.5 19.9008C4.5 21.0606 5.4402 22.0008 6.6 22.0008Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.85 13.7508C13.0098 13.7508 13.95 12.8106 13.95 11.6508C13.95 10.491 13.0098 9.55078 11.85 9.55078C10.6902 9.55078 9.75 10.491 9.75 11.6508C9.75 12.8106 10.6902 13.7508 11.85 13.7508Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 5.8C18.4254 5.8 19.5 4.72548 19.5 3.4C19.5 2.07452 18.4254 1 17.1 1C15.7745 1 14.7 2.07452 14.7 3.4C14.7 4.72548 15.7745 5.8 17.1 5.8Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 22.0008C18.2598 22.0008 19.2 21.0606 19.2 19.9008C19.2 18.741 18.2598 17.8008 17.1 17.8008C15.9402 17.8008 15 18.741 15 19.9008C15 21.0606 15.9402 22.0008 17.1 22.0008Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 13.7508C22.7598 13.7508 23.7 12.8106 23.7 11.6508C23.7 10.491 22.7598 9.55078 21.6 9.55078C20.4402 9.55078 19.5 10.491 19.5 11.6508C19.5 12.8106 20.4402 13.7508 21.6 13.7508Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1 13.7508C3.2598 13.7508 4.2 12.8106 4.2 11.6508C4.2 10.491 3.2598 9.55078 2.1 9.55078C0.940202 9.55078 0 10.491 0 11.6508C0 12.8106 0.940202 13.7508 2.1 13.7508Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11771_94919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcentric);
export default __webpack_public_path__ + "static/media/concentric.d262166a056d96ec310cb9da87521340.svg";
export { ForwardRef as ReactComponent };